import React, {useEffect} from 'react'
import {useBoolean} from '@containers/hooks'
import {Select} from '../select'
import {MenuList} from './menu-list'
import {DropdownListProps} from './types'
import {getMultiSelectText} from './utils'

export const DropdownList = <T,>(props: DropdownListProps<T>) => {
  const {initialOpen = false, disabled = false, size, dot} = props
  const {className, link, placeholder, options, label} = props
  const {value, onChange, onOpenChange, onMultiChange} = props
  const {icon, labelStyle, menuListClassName} = props
  const {multi, withoutAll, allText, selectStyle} = props
  const isMulti = multi && Array.isArray(value)

  const openState = useBoolean(initialOpen)

  useEffect(() => {
    onOpenChange?.(openState.value)
  }, [openState.value])

  const list = (
    <MenuList<T>
      size={size}
      value={value}
      className={menuListClassName}
      items={options}
      onChange={value => {
        Array.isArray(value) ? onMultiChange?.(value) : onChange?.(value)
        openState.turnOff()
      }}
      multi={multi}
      withoutAll={withoutAll}
      allText={allText}
    />
  )

  const currentValue = isMulti
    ? getMultiSelectText({
        value: value,
        options: options,
        allText
      })
    : options.find(x => x.value === value)?.label

  return (
    <Select
      onOpenChange={openState.setValue}
      disabled={disabled}
      size={size}
      open={openState.value}
      link={link}
      content={list}
      className={className}
      placeholder={placeholder}
      label={label}
      dot={dot}
      icon={icon}
      labelStyle={labelStyle}
      selectStyle={selectStyle}
    >
      {currentValue}
    </Select>
  )
}
